<template>
  <div>
    <Plan></Plan>
    <CustomMessageModal></CustomMessageModal>
    <EventModal></EventModal>
    <ModalChangeOrderDetail></ModalChangeOrderDetail>
    <HistoryModal></HistoryModal>
    <BulkCreateEvents></BulkCreateEvents>
    <DraftEventModal></DraftEventModal>
    <EventDetailModal></EventDetailModal>
    <ManageEmailModal></ManageEmailModal>
    <EventStaffingDetail></EventStaffingDetail>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';
  import Plan from '../../../components/eventManagement/main/Plan.vue';
  import EventModal from '../../../components/modal/Modal';
  import ModalChangeOrderDetail from '../../../components/modal/ModalChangeOrderDetail';
  import HistoryModal from '../../../components/modal/HistoryModal';
  import BulkCreateEvents from '../../../components/modal/BulkCreateEvents';
  import DraftEventModal from '../../../components/modal/DraftEventModal';
  import CustomMessageModal from '../../../components/modal/CustomMessageModal';
  import EventDetailModal from '../../../components/modal/event/EventDetailModal';
  import ManageEmailModal from '../../../views/email/ManageEmail';
  import EventStaffingDetail from '../../staffing/EventStaffingDetail';

  import Icon from 'vue-awesome/components/Icon';
  import 'vue-awesome/icons/file-excel-o';
  import 'vue-awesome/icons/question-circle-o';
  import 'vue-awesome/icons/sort-down';
  import 'vue-awesome/icons/users';

  export default {
    name: 'c-plan-client-view',
    components: {
      Icon,
      Plan,
      EventModal,
      ModalChangeOrderDetail,
      HistoryModal,
      BulkCreateEvents,
      DraftEventModal,
      CustomMessageModal,
      EventDetailModal,
      ManageEmailModal,
      EventStaffingDetail
    },
    data () {
      return {};
    },
    computed: {
      ...mapGetters({})
    },
    methods: {
      ...mapActions({})
    },
    beforeMount () {
    },
    mounted () {
    },
    watch: {}
  };
</script>

<style lang="less">
  @import '../../../styles/variables.less';
</style>



// WEBPACK FOOTER //
// Plan.vue?690c2dfe